/**
 * navigation.js
 *
 * Handles toggling the navigation menu for small screens.
 */
( function() {
	var nav = document.getElementById( 'site-navigation' ), button, menu;
	if ( ! nav )
		return;
	button = nav.getElementsByTagName( 'h3' )[0];
	menu   = nav.getElementsByTagName( 'ul' )[0];
	if ( ! button )
		return;

	// Hide button if menu is missing or empty.
	if ( ! menu || ! menu.childNodes.length ) {
		button.style.display = 'none';
		return;
	}

	button.onclick = function() {
		if ( -1 == menu.className.indexOf( 'nav-menu' ) )
			menu.className = 'nav-menu';
			jQuery("ul#menu-top-menu").slideUp();

		if ( -1 != button.className.indexOf( 'toggled-on' ) ) {
			button.className = button.className.replace( ' toggled-on', '' );
			menu.className = menu.className.replace( ' toggled-on', '' );
			jQuery("ul#menu-top-menu").slideUp();
		} else {
			button.className += ' toggled-on';
			menu.className += ' toggled-on';
			jQuery("ul#menu-top-menu").slideDown();
		}
	};
	
	var showSubNav = function(){
		jQuery(this).addClass("open-subnav");
	};
	var hideSubNav = function(){
		jQuery(this).removeClass("open-subnav");
	};
	var cachedScreenwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	jQuery(window).on("load resize",function(){
		var screenwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		if (screenwidth >= 768) {
			jQuery("ul#menu-top-menu li").on("mouseenter", showSubNav);
			jQuery("ul#menu-top-menu li").on("mouseleave", hideSubNav);
		}
		if (screenwidth !== cachedScreenwidth && screenwidth >= 768) {
			jQuery("ul#menu-top-menu").show();
		}
		if (screenwidth !== cachedScreenwidth && screenwidth <= 767) {
			jQuery("ul#menu-top-menu").hide();
		}
		if (screenwidth <= 767) {
			jQuery("ul#menu-top-menu li").off("mouseenter", showSubNav);
			jQuery("ul#menu-top-menu li").off("mouseleave", hideSubNav);
		}
	});
	
} )();